import { PureComponent } from 'react';

import classNames from 'classnames';
import FormErrorMessage from 'components/FormErrorMessage';
import get from 'lodash/get';
import handleEvent from 'utils/handleEvent';

class LayoutField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showHover: false,
    };
  }

  getTitle = () => {
    const {
      input: { value },
      msg,
    } = this.props;
    switch (value) {
      case 'x':
        return get(msg, ['dialog', 'addRow', 'x']);
      case 'xx':
        return get(msg, ['dialog', 'addRow', 'xx']);
      case 'xxx':
        return get(msg, ['dialog', 'addRow', 'xxx']);
      default:
        return '';
    }
  };

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: legacy code
  getLayout = () => {
    const {
      input: { value },
      msg,
    } = this.props;
    const { showHover } = this.state;
    switch (value) {
      case 'x':
        return (
          <div className='dashboard-layout-field__layout-wrapper'>
            <table className='noselect w-full border-collapse'>
              <tbody>
                <tr>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      case 'xx':
        return (
          <div className='dashboard-layout-field__layout-wrapper'>
            <table className='noselect w-full border-collapse'>
              <tbody>
                <tr>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      case 'xxx':
        return (
          <div className='dashboard-layout-field__layout-wrapper'>
            <table className='noselect w-full border-collapse'>
              <tbody>
                <tr>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                  <td
                    className={classNames(
                      'dashboard-layout-field__td',
                      showHover && 'dashboard-layout-field__td--hover',
                    )}
                  >
                    {!showHover ? (
                      get(msg, ['dialog', 'column'])
                    ) : (
                      <span className='dashboard__empty-icon' />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      default:
        return null;
    }
  };

  handleMouseEnter = handleEvent(() => {
    this.setState({ showHover: true });
  });

  handleMouseLeave = handleEvent(() => {
    this.setState({ showHover: false });
  });

  render() {
    const {
      input,
      msg,
      meta: { touched, error },
      onSelect,
    } = this.props;
    const { showHover } = this.state;
    return (
      <div>
        <div
          className='relative'
          onClick={onSelect}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          data-testid={`layout-field-${input.value}`}
        >
          {showHover ? (
            <div className='dashboard-layout-field__hover-block'>
              <i className='fa fa-regular fa-circle-plus fa-2x' />
              <div className='ml-2'>{this.getTitle()}</div>
            </div>
          ) : null}
          {this.getLayout(input.value, input.checked, msg)}
          {touched && input.value === 'xxx' && error && (
            <FormErrorMessage>{msg.validation[error]}</FormErrorMessage>
          )}
        </div>
      </div>
    );
  }
}

export default LayoutField;
